import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import ServiceAreasPage from '@/pages/service-areas/page';
import BlogPage from '@/pages/blog/page';
import BlogArticlePage from '@/pages/blog/article';
import AboutPage from '@/pages/about/page';
import GalleryPage from '@/pages/gallery/page';
import ReviewsPage from '@/pages/reviews/page';
import ContactPage from '@/pages/contact/page';
import FreeQuotePage from '@/pages/free-quote/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/service-areas', element: <ServiceAreasPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/free-quote', element: <FreeQuotePage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:slug', element: <BlogArticlePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
